export class StringUtilities {
  static shorten(text, maxLength, delimiter, overflow) {
    if (!text) { return ''; }
    delimiter = delimiter || '&hellip;';
    overflow = overflow || false;
    let ret = text;
    if (ret.length > maxLength) {
      const breakpoint = overflow ? maxLength + ret.substr(maxLength).indexOf(' ') : ret.substr(0, maxLength).lastIndexOf(' ');
      ret = ret.substr(0, breakpoint) + delimiter;
    }
    return ret;
  }
}
